import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    modalComponent: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '480px',
        height: '378px',
        backgroundColor: '#FFFFFF',
        boxShadow: '0px 2px 4px rgba(125, 149, 165, 0.5)',
        borderRadius: '10px'
    },
    rectangleBlue: {
        position: 'absolute',
        width: '480px',
        height: '143px',
        left: '0px',
        top: '0px',
        background: '#225384',
        borderTopRightRadius: '10px',
        borderTopLeftRadius: '10px'
    },
    amountToPay: {
        position: 'absolute',
        width: '195px',
        height: '43px',
        alignSelf: 'center',
        left: '143px',
        top: '37px',
        fontFamily: 'Montserrat',
        color: '#FFFFFF',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '35px',
        lineHeight: '43px'
    },
    payBalanceText: {
        position: 'absolute',
        width: '100px',
        height: '16px',
        left: '196px',
        top: '90px',
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '12px',
        lineHeight: '16px',
        textTransform: 'uppercase',
        color: '#D8DDE2'
    },
    cancelButton: {
        position: 'absolute',
        width: '109px',
        height: '40px',
        left: '178px',
        top: '309px',
        border: '1px solid #7D95A5',
        borderRadius: '50px',
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'medium',
        fontSize: '13px',
        lineHeight: '20px'
    },
    applyPaymentDisabled: {
        position: 'absolute',
        width: '137px',
        height: '40px',
        fontSize: '13px',
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'medium',
        lineHeight: '20px',
        left: '303px',
        top: '309px',
        backgroundColor: '#D8DDE2',
        borderRadius: '20px',
        border: 'none'
    },
    applyPaymentEnabled: {
        position: 'absolute',
        width: '137px',
        height: '40px',
        left: '303px',
        top: '309px',
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontSize: '13px',
        fontWeight: 'normal',
        lineHeight: '20px',
        backgroundColor: '#1BABE2',
        borderRadius: '20px',
        border: 'none',
        color: '#FFFFFF'
    },
    containerSelect: {
        position: 'absolute',
        width: '400px',
        height: '66px',
        left: '40px',
        top: '183px'
    },
    selectComponent: {
        width: '392px',
        height: '40px',
        borderRadius: ['3px', '3px'],
        background: '#FFFFFF',
        border: '1px solid #D8DDE2',
        boxSizing: 'border-box'
    },
    addBank: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '13px',
        lineHeight: '18px',
        color: '#1BABE2',
        marginTop: '8px',
        marginLeft: '10px',
        cursor: 'pointer'
    },
    labelPayFrom: {
        position: 'absolute',
        width: '84px',
        height: '22px',
        left: '10px',
        top: '-15px',
        color: '#225384',
        lineHeight: '22px',
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: '14px'
    },
    selectInputLabel: {
        position: 'absolute',
        width: '84px',
        height: '22px',
        top: '-5px',
        color: '#225384',
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '14px'
    },
    selectOption: {
        fontFamily: 'Montserrat',
        fontWeight: '500',
        fontSize: '14px'
    },
    modalPaymentApproved: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '90px'
    },
    paymentApproved: {
        flexDirection: 'column',
        top: '79px',
        left: '196px',
        height: '96px',
        width: '107px'
    },
    paymentSuccesful: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '22px',
        lineHeight: '27px',
        color: '#182D55',
        marginTop: '12px'
    },
    complementPayment: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '13px',
        lineHeight: '16px',
        textAlign: 'center',
        color: '#182D55',
        marginTop: '8px'
    },
    buttonDone: {
        background: '#1BABE2',
        borderRadius: '20px',
        height: '40px',
        width: '200px',
        border: 'none',
        color: 'white',
        marginTop: '30px'
    },
    addBankAccount: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '18px',
        lineHeight: '22px',
        textAlign: 'right',
        color: '#182D55'
    },
    addBankSecondaryText: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '13px',
        lineHeight: '20px',
        color: '#225384'
    },
    banksContainer: {
        position: 'absolute',
        width: '436px',
        height: '144px',
        left: '32px',
        right: '32px',
        top: '107px'
    }
});

export default useStyles;
